// src/app/useFraicheurBeds24.js — le point « dernier signal Beds24 » du bandeau.
// Déplacé à l'identique depuis src/App.jsx (P-3.5, squelette). Lecture seule.

import { supabase } from '../supabase'
import { useState, useEffect } from 'react'

export function useFraicheurBeds24({ ready, currentUser }) {
  // v3 ÉTAPE 1 (read-path Beds24) — fraîcheur réelle Beds24 : { lastEventAt,
  // lastPollAt } lus (admin only) sur le GET admin /api/beds24-mapping
  // (webhook_status.last_event_at + sync_state.last_poll_at). Alimente
  // l'indicateur « Sync Beds24 HH:MM » du bandeau. LECTURE SEULE.
  const [beds24Sync, setBeds24Sync] = useState(null)
  // v3 ÉTAPE 1 (read-path Beds24) — fraîcheur réelle Beds24 pour le bandeau.
  // Lecture seule, admin only (le GET /api/beds24-mapping exige requireAdmin) :
  // on ne retient que webhook_status.last_event_at + sync_state.last_poll_at
  // (calque l'endpoint admin déjà utilisé par Beds24SyncPanel). Best-effort :
  // un échec laisse simplement l'indicateur masqué. Rafraîchi au mount + toutes
  // les 5 min + au retour de visibilité.
  useEffect(() => {
    if (!ready) return
    if (currentUser?.role !== "admin") return
    let cancelled = false
    const load = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession()
        if (!session?.access_token) return
        const res = await fetch('/api/beds24-mapping', {
          headers: { Authorization: `Bearer ${session.access_token}` },
        })
        if (!res.ok) return
        const json = await res.json()
        if (cancelled) return
        setBeds24Sync({
          lastEventAt: json?.webhook_status?.last_event_at || null,
          lastPollAt: json?.sync_state?.last_poll_at || null,
          // Lot L2 (P-3.37, 30/10) : Beds24 en sommeil — l'indicateur se masque.
          enSommeil: json?.beds24_en_sommeil === true,
        })
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('[App] beds24 freshness fetch error', e)
      }
    }
    load()
    const interval = setInterval(load, 5 * 60 * 1000)
    const onVisible = () => { if (document.visibilityState === 'visible') load() }
    document.addEventListener('visibilitychange', onVisible)
    return () => {
      cancelled = true
      clearInterval(interval)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [ready, currentUser])
  return { beds24Sync }
}
